/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Resource Explorer Service API
 * OpenAPI spec version: 0.1.0
 */
import type {HttpContext, HttpEvent, HttpParams} from '@angular/common/http';
import {HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders} from '@angular/common/http';

import {Injectable, inject} from '@angular/core';

import {Observable} from 'rxjs';

import {APP_ENVIRONMENT} from '@app/core/tokens/app-environment.token';
import {type AppEnvironment} from '@models/environment';

import type {
  CategoryCreate,
  GetCategoriesByLevelParams,
  GetCategoryByLevelAndIdParams,
  PrimaryCategoryChildrenListResponse,
  PrimaryCategoryChildrenResponse,
  PrimaryCategoryParentListResponse,
  PrimaryCategoryParentResponse,
  SecondaryCategoryChildrenListResponse,
  SecondaryCategoryChildrenResponse,
  SecondaryCategoryParentListResponse,
  SecondaryCategoryParentResponse,
  TertiaryCategoryChildrenListResponse,
  TertiaryCategoryChildrenResponse,
  TertiaryCategoryParentListResponse,
  TertiaryCategoryParentResponse,
} from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?: HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (
      value != null &&
      (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}

@Injectable({providedIn: 'root'})
export class CategoryService {
  public http = inject(HttpClient);
  _environment: AppEnvironment = inject(APP_ENVIRONMENT);
  _baseUrl: string | undefined = undefined;

  get baseUrl(): string {
    return this._baseUrl ?? this._environment.api;
  }

  set baseUrl(newUrl: string) {
    this._baseUrl = newUrl;
  }

  /**
   * Creates a new category
   * @summary Create Category
   */
  createCategory<TData = unknown | void>(
    categoryCreate: CategoryCreate,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  createCategory<TData = unknown | void>(
    categoryCreate: CategoryCreate,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  createCategory<TData = unknown | void>(
    categoryCreate: CategoryCreate,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  createCategory<TData = unknown | void>(
    categoryCreate: CategoryCreate,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/api/categories`, categoryCreate, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/api/categories`, categoryCreate, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/api/categories`, categoryCreate, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Updates an existing category
   * @summary Update Category
   */
  updateCategory<TData = unknown | void>(
    categoryId: string,
    categoryCreate: CategoryCreate,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  updateCategory<TData = unknown | void>(
    categoryId: string,
    categoryCreate: CategoryCreate,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  updateCategory<TData = unknown | void>(
    categoryId: string,
    categoryCreate: CategoryCreate,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  updateCategory<TData = unknown | void>(
    categoryId: string,
    categoryCreate: CategoryCreate,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(`${this.baseUrl}/api/categories/${categoryId}`, categoryCreate, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(`${this.baseUrl}/api/categories/${categoryId}`, categoryCreate, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.put<TData>(`${this.baseUrl}/api/categories/${categoryId}`, categoryCreate, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Gets categories by level, and also returns all parent or children categories depending on `hierarchy`.
   * For example, if `level`=`tertiary` and `hierarchy`=`parent`, then also returns secondary and primary
   * categories. If `hierarchy`=`children`, then only returns tertiary categories since there are no children
   * categories for tertiary categories.
   * @summary Get Categories By Level
   */
  getCategoriesByLevel<
    TData =
      | PrimaryCategoryParentListResponse
      | PrimaryCategoryChildrenListResponse
      | SecondaryCategoryParentListResponse
      | SecondaryCategoryChildrenListResponse
      | TertiaryCategoryParentListResponse
      | TertiaryCategoryChildrenListResponse,
  >(
    level: 'primary' | 'secondary' | 'tertiary',
    params?: GetCategoriesByLevelParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getCategoriesByLevel<
    TData =
      | PrimaryCategoryParentListResponse
      | PrimaryCategoryChildrenListResponse
      | SecondaryCategoryParentListResponse
      | SecondaryCategoryChildrenListResponse
      | TertiaryCategoryParentListResponse
      | TertiaryCategoryChildrenListResponse,
  >(
    level: 'primary' | 'secondary' | 'tertiary',
    params?: GetCategoriesByLevelParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getCategoriesByLevel<
    TData =
      | PrimaryCategoryParentListResponse
      | PrimaryCategoryChildrenListResponse
      | SecondaryCategoryParentListResponse
      | SecondaryCategoryChildrenListResponse
      | TertiaryCategoryParentListResponse
      | TertiaryCategoryChildrenListResponse,
  >(
    level: 'primary' | 'secondary' | 'tertiary',
    params?: GetCategoriesByLevelParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getCategoriesByLevel<
    TData =
      | PrimaryCategoryParentListResponse
      | PrimaryCategoryChildrenListResponse
      | SecondaryCategoryParentListResponse
      | SecondaryCategoryChildrenListResponse
      | TertiaryCategoryParentListResponse
      | TertiaryCategoryChildrenListResponse,
  >(
    level: 'primary' | 'secondary' | 'tertiary',
    params?: GetCategoriesByLevelParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/api/categories/${level}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/api/categories/${level}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/api/categories/${level}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Deletes category permanently.
   * @summary Delete Category By Level And Id
   */
  deleteCategoryByLevelAndId<TData = unknown>(
    level: 'primary' | 'secondary' | 'tertiary',
    categoryId: string,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  deleteCategoryByLevelAndId<TData = unknown>(
    level: 'primary' | 'secondary' | 'tertiary',
    categoryId: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  deleteCategoryByLevelAndId<TData = unknown>(
    level: 'primary' | 'secondary' | 'tertiary',
    categoryId: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  deleteCategoryByLevelAndId<TData = unknown>(
    level: 'primary' | 'secondary' | 'tertiary',
    categoryId: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(`${this.baseUrl}/api/categories/${level}/${categoryId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(`${this.baseUrl}/api/categories/${level}/${categoryId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.delete<TData>(`${this.baseUrl}/api/categories/${level}/${categoryId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Gets a category by level and id, and also returns all parent or children categories depending on `hierarchy`.
   * For example, if `level`=`tertiary` and `hierarchy`=`parent`, then also returns secondary and primary
   * categories. If `hierarchy`=`children`, then only returns tertiary categories since there are no children
   * categories for tertiary categories.
   * @summary Get Category By Level And Id
   */
  getCategoryByLevelAndId<
    TData =
      | PrimaryCategoryParentResponse
      | PrimaryCategoryChildrenResponse
      | SecondaryCategoryParentResponse
      | SecondaryCategoryChildrenResponse
      | TertiaryCategoryParentResponse
      | TertiaryCategoryChildrenResponse,
  >(
    level: 'primary' | 'secondary' | 'tertiary',
    categoryId: string,
    params?: GetCategoryByLevelAndIdParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getCategoryByLevelAndId<
    TData =
      | PrimaryCategoryParentResponse
      | PrimaryCategoryChildrenResponse
      | SecondaryCategoryParentResponse
      | SecondaryCategoryChildrenResponse
      | TertiaryCategoryParentResponse
      | TertiaryCategoryChildrenResponse,
  >(
    level: 'primary' | 'secondary' | 'tertiary',
    categoryId: string,
    params?: GetCategoryByLevelAndIdParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getCategoryByLevelAndId<
    TData =
      | PrimaryCategoryParentResponse
      | PrimaryCategoryChildrenResponse
      | SecondaryCategoryParentResponse
      | SecondaryCategoryChildrenResponse
      | TertiaryCategoryParentResponse
      | TertiaryCategoryChildrenResponse,
  >(
    level: 'primary' | 'secondary' | 'tertiary',
    categoryId: string,
    params?: GetCategoryByLevelAndIdParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getCategoryByLevelAndId<
    TData =
      | PrimaryCategoryParentResponse
      | PrimaryCategoryChildrenResponse
      | SecondaryCategoryParentResponse
      | SecondaryCategoryChildrenResponse
      | TertiaryCategoryParentResponse
      | TertiaryCategoryChildrenResponse,
  >(
    level: 'primary' | 'secondary' | 'tertiary',
    categoryId: string,
    params?: GetCategoryByLevelAndIdParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/api/categories/${level}/${categoryId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/api/categories/${level}/${categoryId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/api/categories/${level}/${categoryId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
}

export type CreateCategoryClientResult = NonNullable<unknown | void>;
export type UpdateCategoryClientResult = NonNullable<unknown | void>;
export type GetCategoriesByLevelClientResult = NonNullable<
  | PrimaryCategoryParentListResponse
  | PrimaryCategoryChildrenListResponse
  | SecondaryCategoryParentListResponse
  | SecondaryCategoryChildrenListResponse
  | TertiaryCategoryParentListResponse
  | TertiaryCategoryChildrenListResponse
>;
export type DeleteCategoryByLevelAndIdClientResult = NonNullable<unknown>;
export type GetCategoryByLevelAndIdClientResult = NonNullable<
  | PrimaryCategoryParentResponse
  | PrimaryCategoryChildrenResponse
  | SecondaryCategoryParentResponse
  | SecondaryCategoryChildrenResponse
  | TertiaryCategoryParentResponse
  | TertiaryCategoryChildrenResponse
>;
